export default "__VITE_ASSET__ntdRKe4t__"